import Table from "./table";
import { store } from "@/store/store";
import localScaleManager from "../../../helpers/LocalScaleManager";
import * as Sentry from "@sentry/browser";

export default class TournamentTable extends Table {
  constructor(scene, tableNumber, tableInfo, tableWallet) {
    super(scene, tableNumber, tableInfo, tableWallet);
    this.smallBlind = 0;
    this.bigBlind = 0;
    this.ante = 0;
    this.nextSB = 0;
    this.nextBB = 0;
    this.nextAnte = 0;
    this.level = 0;
    this.rank = 0;
    this.totalPlayers = 0;
    this.blindsUpTotalSeconds = 0;
    this.setCongratsMessage = null;
    // this.remainingTime = 30;

    this.blindsUpTxt = this.createBitmapText(scene, "HelveticaNeue", 0.4);
    this.name = this.createBitmapText(scene, "HelveticaNeueGray", 0.8);

    this.timer = this.createTimer(scene);
  }
  createBitmapText(scene, font, alpha) {
    const text = scene.add
      .bitmapText(0, 0, font, "".padStart(30, "a"))
      .setVisible(false)
      .setAlpha(alpha);
    this.poolArray.push(text);
    text.setData("width", text.width);
    text.setData("height", text.height);
    return text;
  }
  createTimer(scene) {
    const timer = scene.time.addEvent({
      delay: 1000,
      callback: this.timeEvent,
      callbackScope: this,
      repeat: -1,
    });
    this.poolArray.push(timer);
    timer.paused = true;
    return timer;
  }
  isTournamentTable() {
    return true;
  }
  async handleGameState(state, isPulled) {
    if (state.src === "Merge-faze" || !this.scene.positionsWereControlled)
      return;

    this.firstGameState = this.firstGameState === null;
    this.manageAudio(isPulled);

    this.gameState = state;
    this.updateTournamentName();
    this.updateGameInfoText();
    this.updateBlindsText();
    this.updateBlindsUpText();
    this.initializePreviousPlayer(state);

    this.updateSeats(state);
    await this.handleSelfPlayer(state, this.isTableVisiting());

    this.seatManager.checkActionsStatus(this.seats, state.state);

    this.updateDealerPosition(state);

    this.deactivateSeats(state);

    this.stateManager(state);

    this.tableTimer.handleGameState(state);

    if (!(state.state === "PreFlop" && state.newState))
      this.buttonManager.handleGameState(state);

    this.pots.handleGameState(state);
    this.handleTournamentRebuyModal();
    this.handleResultModal();
    this.handleAddOnModal();
    this.handleBuyInMenuBtn();

    if (state.state === "PreMerge") this.managePreMerge();

    this.manageEndedGames();

    this.previousPlayerInTurn = state.playerInTurn;
  }

  async processSeatedPlayer(state, isTableVisiting) {
    if (
      state.playerInfo.id === state.playerInTurn &&
      state.playerInfo.autoAction === "None"
    ) {
      this.scene.manageAutoSwitchTables(this.tableInfo.id);
    }

    if (!this.seatManager.hasSelfPlayerSat()) {
      /* The first game state that the self-player joined the table */
      await this.repositionSeats(state.playerInfo.position, false);
      this.markSelfPlayerSeat(state);
      this.updateSelfPlayerInfo(state);
    } else {
      await this.updateSelfPlayerPosition(state);
    }
    this.checkSelfPlayerPosition(state);
  }

  checkSelfPlayerPosition(state) {
    const selfPlayerBox = this.seatManager.getSeatByServerPosition(
      state.playerInfo.position
    ).box;
    const centerButtonBox = this.seatManager.getSeatByPosition("cb").box;
    if (
      selfPlayerBox.x === centerButtonBox.x &&
      selfPlayerBox.y === centerButtonBox.y
    )
      return;
    console.log(
      "Seats repositioning is necessary to maintain the self-player's position"
    );
    const seatsData = this.seats.map((seat) => {
      return {
        position: seat.position,
        serverPosition: seat.serverPosition,
        playerInfo: seat.playerInfo,
        playerId: seat.playerId,
        isMyTable: seat.isMyTable,
      };
    });
    Sentry.captureException(
      `Seats repositioning is necessary: selfPlayerPositionObj: ${JSON.stringify(
        this.seatManager.getPositionByServerPosition(state.playerInfo.position)
      )},seats: ${JSON.stringify(seatsData)}`,
      { extraData: this.gameState }
    );
    window.location.reload();
  }
  async processUnseatedPlayer() {
    /* If the self-player has not sat yet*/
    if (this.showHandMenu) this.showHandMenu.hide();

    if (this.seatManager.hasSelfPlayerSat()) {
      /* The first game state that the self-player left the table */
      this.resetSeats();
      await this.repositionSeats(1, false);
      this.updateSeatPositions();
    }
  }
  managePreMerge() {
    this.cardsIdleState();
    this.playerSeats.forEach((seat) => {
      if (seat.playerInfo.state !== "SitOut") seat.setDisable(false);
      seat.compeleteWin();
    });
  }
  manageEndedGames() {
    if (!this.gameState.outPlayer && this.gameState.ended) {
      this.scene.setATimeout(() => {
        /* If it's the first game state after the game is loaded, there may be a delay as the positioning process completes. */
        const deletedTable =
          this && this.scene
            ? this.scene.getTableGameById(this.tableInfo.id)
            : null;
        if (deletedTable) {
          deletedTable.observeNotTable().finally(() => {
            if (this && this.scene) this.scene.deleteTable(this.tableInfo.id);
          });
        }
      }, 3000);
    }
  }
  updateBlindsText() {
    const somethingChanged =
      this.smallBlind !== this.gameState.smallBlind ||
      this.bigBlind !== this.gameState.bigBlind ||
      this.ante !== this.gameState.ante ||
      this.level !== this.gameState.tournamentLevel;
    if (!somethingChanged) return;
    this.smallBlind = this.gameState.smallBlind ? this.gameState.smallBlind : 0;
    this.bigBlind = this.gameState.bigBlind ? this.gameState.bigBlind : 0;
    this.ante = this.gameState.ante ? this.gameState.ante : 0;
    this.level = this.gameState.tournamentLevel
      ? this.gameState.tournamentLevel
      : 0;

    let firstTxt = +this.ante
      ? `Level(${
          this.level
        }): ${this.smallBlind.toLocaleString()}/${this.bigBlind.toLocaleString()} (${this.ante.toLocaleString()})`
      : `Level(${
          this.level
        }): ${this.smallBlind.toLocaleString()}/${this.bigBlind.toLocaleString()}`;
    this.tableInfoTxt.setText(firstTxt);
    this.tableInfoTxt.setX(
      this.x + (this.displayWidth - this.tableInfoTxt.width) / 2
    );
    if (!this.tableInfoTxt.visible) this.tableInfoTxt.setVisible(true);
  }

  updateBlindsUpText() {
    if (!this.gameState.stopTimers)
      this.startTimer(this.gameState.nextBlindsTime);
    else {
      this.stopTimer();
    }
    const somethingChanged =
      this.nextSB !== this.gameState.nextSB ||
      this.nextBB !== this.gameState.nextBB ||
      this.nextAnte !== this.gameState.nextAnte;
    if (!somethingChanged) return;
    this.nextSB = this.gameState.nextSB ? this.gameState.nextSB : 0;
    this.nextBB = this.gameState.nextBB ? this.gameState.nextBB : 0;
    this.nextAnte = this.gameState.nextAnte ? this.gameState.nextAnte : 0;
  }

  updateTournamentName() {
    const somethingChanged =
      this.rank !== this.gameState.tournamentRank ||
      this.totalPlayers !== this.gameState.totalPlayers;
    if (!somethingChanged) return;
    this.rank = this.gameState.tournamentRank
      ? this.gameState.tournamentRank
      : 0;
    this.totalPlayers = this.gameState.totalPlayers
      ? this.gameState.totalPlayers
      : 0;

    this.name.setText(
      this.gameState.tournamentName +
        " " +
        this.gameState.type +
        `(👤${this.rank}/${this.totalPlayers})`
    );
    this.name.setX(this.x + (this.displayWidth - this.name.width) / 2);
    if (!this.name.visible) this.name.setVisible(true);
  }
  timeEvent() {
    this.blindsUpTotalSeconds--;
    if (this.blindsUpTotalSeconds <= 0) {
      this.timer.paused = true;
      // this.totalSeconds = this.remainingTime;
    }
    // if(this.totalSeconds >= 3600) {
    let timerText =
      this.blindsUpTotalSeconds > -1
        ? `${new Date(this.blindsUpTotalSeconds * 1000)
            .toISOString()
            .substr(14, 5)}`
        : "";
    let text = +this.nextAnte
      ? `${timerText} Blinds up: ${this.nextSB.toLocaleString()}/${this.nextBB.toLocaleString()} (${this.nextAnte.toLocaleString()})`
      : `${timerText} Blinds up: ${this.nextSB.toLocaleString()}/${this.nextBB.toLocaleString()}`;
    this.blindsUpTxt.setText(text);
    this.blindsUpTxt.setX(
      this.x + (this.displayWidth - this.blindsUpTxt.width) / 2
    );
    if (!this.blindsUpTxt.visible) this.blindsUpTxt.setVisible(true);
  }
  /**
   * @param time{number} remainingTime (ms)
   */
  startTimer(time) {
    this.blindsUpTotalSeconds = Math.trunc(time / 1000);
    if (this.timer.paused) this.timer.paused = false;
  }
  stopTimer() {
    this.blindsUpTotalSeconds = 1;
    // if (!this.timer.paused) this.timer.paused = true;
  }
  hideCashGameModals() {
    if (!this.isTableVisiting() || !this.scene.hasCashGameTable()) return;

    /* Hide Reserve Modal */
    const reserveModal = this.scene.reserveModal;
    reserveModal.hide();

    /* Hide Add More Chip Modal */
    const addMoreChipModal = this.scene.addMoreChipModal;
    addMoreChipModal.hide();

    /* Hide ReDeal Modal */
    this.scene.alertify.dismissAll();
    this.modalsManager.reDealModal.hide();
  }
  handleTournamentRebuyModal() {
    const isTableVisiting = this.isTableVisiting();
    let state = this.gameState;
    if (isTableVisiting) {
      if (state.playerInfo) {
        if (state.state === "Rebuy") {
          if (state.rebuyPlayers.includes(state.playerInfo.id)) {
            this.showTournamentRebuy(true);
          } else {
            this.waitingForOthersRebuy();
          }
        } else {
          this.showTournamentRebuy(false);
        }
      } else {
        this.showTournamentRebuy(false);
      }
    } else if (this.scene.autoSwitchTables) {
      if (
        state.state === "Rebuy" &&
        state.playerInfo &&
        state.rebuyPlayers.includes(state.playerInfo.id)
      ) {
        this.scene.changeVisitedTableGame(this.tableNumber - 1);
        this.scene.chat.hide();
        this.scene.replayHandMenu.hide();
        this.scene.realTimeResultsMenu.hide();
        this.showTournamentRebuy(true);
      }
    }
  }
  handleResultModal() {
    if (!this.isTableVisiting()) return;
    const status = !!this.gameState.outPlayer;
    this.scene.registry.set("showTournamentResult", status);
  }
  handleAddOnModal() {
    const isTableVisiting = this.isTableVisiting();
    let state = this.gameState;
    if (isTableVisiting) {
      // if (state.playerInfo && state.state === "AddOnBreak") {
      //   this.showTournamentAddOn(true, true);
      // } else
      if (
        state.state === "AddOnPhase" &&
        state.playerInfo &&
        state.rebuyPlayers.includes(state.playerInfo.id)
      ) {
        this.showTournamentAddOn(true, false);
        this.buttonManager.addOnBtn.show();
      } else {
        this.buttonManager.hideAddOnBtn();
        this.showTournamentAddOn(false, false);
      }
    }
  }
  showTournamentRebuy(show) {
    if (show) {
      this.scene.registry.set("waitingForOthersToRebuy", false);
      this.scene.registry.set("userClubId", this.gameState.playerInfo.clubId);
      this.scene.registry.set("addon", this.gameState.addOnFaze);
    }
    this.scene.registry.set("showTournamentRebuy", show);
  }
  showTournamentAddOn(show, force) {
    const clubId = this.gameState?.playerInfo?.clubId
      ? this.gameState.playerInfo.clubId
      : "";
    const oldVal = store.getters.getTournamentAddOnInfo;
    if (!force && oldVal.closedByUser) return;
    const info = {
      show: show,
      addOnBreak: false,
      clubId: clubId,
      closedByUser: false,
    };
    if (JSON.stringify(oldVal) === JSON.stringify(info)) return;
    store.commit("setTournamentAddOnInfo", info);
  }
  waitingForOthersRebuy() {
    this.scene.registry.set("waitingForOthersToRebuy", true);
    this.scene.registry.set("showTournamentRebuy", true);
  }
  showCongratsMessage() {
    let data = this.congratsData;
    this.scene.Swal.fire({
      title: `🏆 Congratulations ${
        this.gameState &&
        this.gameState.playerInfo &&
        this.gameState.playerInfo.username
          ? this.gameState.playerInfo.username
          : ""
      }!`,
      text: `You've secured a top spot in this tournament and won a prize . Well played! 🎉`,
      showCancelButton: false,
      confirmButtonText: "Awesome!",
      color: "#ffffff",
      background: "#006270",
      confirmButtonColor: "#009394",
      customClass: {
        title: "sweet-alert-title",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.congratsData = null;
      } else {
        this.congratsData = null;
      }
    });
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  positionControls(width, height) {
    super.positionControls(width, height);
    this.blindsUpTxtSize = this.displayWidth / 2.2;
    localScaleManager.scaleBitMapText(
      this.blindsUpTxt,
      this.blindsUpTxtSize,
      this.blindsUpTxtSize,
      0,
      1,
      false
    );
    this.blindsUpTxt.setPosition(
      this.x + (this.displayWidth - this.blindsUpTxt.width) / 2,
      this.tableInfoTxt.y - this.tableInfoTxt.height * 6.4
    );

    localScaleManager.scaleBitMapText(
      this.name,
      this.displayWidth / 1.5,
      this.displayWidth / 1.5,
      0,
      1,
      false
    );
    this.name.setPosition(
      this.x + (this.displayWidth - this.name.width) / 2,
      this.tableInfoTxt.y - this.tableInfoTxt.height * 9
    );
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  reposition(width, height) {
    super.reposition(width, height);
    this.blindsUpTxt.setPosition(
      this.x + (this.displayWidth - this.blindsUpTxt.width) / 2,
      this.tableInfoTxt.y - this.tableInfoTxt.height * 6.4
    );
    this.name.setPosition(
      this.x + (this.displayWidth - this.name.width) / 2,
      this.tableInfoTxt.y - this.tableInfoTxt.height * 9
    );
  }
}
